module.exports = __webpack_public_path__ + "img/img_案例11.e7b0d1ba.png";